<p>
  currency-text works!
</p>
